import { AppError } from "./index";

/**
 * Custom error to encapsulate HTTP unauthorized error.
 */
export class UnauthorizedError extends AppError {}
